import * as PIXI from 'pixi.js'
import { TweenMax } from 'gsap/TweenMax'

class Progress {
  constructor (game) {
    this.game = game
    this.objects = {}

    //
    // Hooks
    //

    this.onLoaded = () => {}
  }

  init () {
    this.drawScene()
    this.loadAssets()
  }

  drawScene () {
    this.game.background.init()

    this.objects = {
      title: new PIXI.Sprite(PIXI.Texture.from('title')),
      man: new PIXI.Sprite(PIXI.Texture.from('man')),
      manInSleep: new PIXI.Sprite(PIXI.Texture.from('manInSleep')),
      counter: new PIXI.Text('00%', {
        fontFamily: '"Lato", "Helvetica Neue", Arial, sans-serif',
        fontSize: 24,
        fill: 0x999999,
        align: 'center'
      })
    }

    this.objects.title.scale.set(0.25)
    this.objects.man.scale.set(0.25)
    this.objects.manInSleep.scale.set(0.25)

    this.manBlurFilter = new PIXI.filters.BlurFilter(0, 1, 2)
    this.manBlurFilter.blur = 0
    this.objects.man.filters = [this.manBlurFilter]

    this.objects.manInSleep.alpha = 0

    this.objects.title.x = (this.game.app.renderer.realWidth - this.objects.title.width) / 2
    this.objects.title.y = 142

    this.objects.man.x = (this.game.app.renderer.realWidth - this.objects.man.width) / 2
    this.objects.man.y = 200
    this.objects.manInSleep.x = (this.game.app.renderer.realWidth - this.objects.manInSleep.width) / 2
    this.objects.manInSleep.y = 200

    this.objects.counter.x = (this.game.app.renderer.realWidth - this.objects.counter.width) / 2
    this.objects.counter.y = 442

    const gman = document.getElementById('gman')
    if (gman) {
      gman.remove()
    }

    this.game.app.stage.addChild(
      this.objects.title,
      this.objects.man,
      this.objects.manInSleep,
      this.objects.counter
    )
  }

  loadAssets () {
    PIXI.loader
      // Audio
      .add('audioBGM1', 'audios/bgm-1.mp3')
      .add('audioBackground', 'audios/background.m4a')
      .add('audioJump', 'audios/jump.wav')
      .add('audioSuperJump', 'audios/super-jump.wav')
      .add('audioFly', 'audios/fly.wav')
      .add('audioNyanMode', 'audios/nyan-3.m4a')
      .add('audioPop', 'audios/pop.mp3')
      .add('audioDing', 'audios/ding.mp3')
      .add('audioSheep1', 'audios/sheep_1.mp3')
      .add('audioSheep2', 'audios/sheep_2.mp3')
      .add('audioSheep3', 'audios/sheep_3.mp3')
      .add('audioSheep4', 'audios/sheep_4.mp3')
      .add('audioSheep5', 'audios/sheep_5.mp3')
      .add('audioSheep6', 'audios/sheep_6.mp3')
      .add('audioSheep7', 'audios/sheep_7.mp3')
      .add('audioSheep8', 'audios/sheep_8.mp3')
      .add('audioGameOver', 'audios/game-over.wav')

      // Jump
      // .add('playerJumping', 'images/jump/sprite-13.json')
      .add('playerJumping', 'images/jump/jumping.png')
      .add('playerSuperJumping', 'images/jump/super-jumping.png')
      .add('z', 'images/jump/z.png')
      .add('jump1', 'images/jump/jump-1.png')
      .add('jump2', 'images/jump/jump-2.png')
      .add('jump3', 'images/jump/jump-3.png')
      .add('jump4', 'images/jump/jump-4.png')
      .add('jump5', 'images/jump/jump-5.png')
      .add('jump6', 'images/jump/jump-6.png')

      // Bubbles
      .add('bubbleMan', 'images/jump/bubble-man.png')
      .add('bubble1', 'images/bubble/bubble-01.png')
      .add('bubble2', 'images/bubble/bubble-02.png')
      .add('bubble3', 'images/bubble/bubble-03.png')
      .add('bubble4', 'images/bubble/bubble-04.png')
      .add('bubble5', 'images/bubble/bubble-05.png')
      .add('bubble6', 'images/bubble/bubble-06.png')
      .add('bubble7', 'images/bubble/bubble-07.png')
      .add('bubble8', 'images/bubble/bubble-08.png')
      .add('bubble9', 'images/bubble/bubble-09.png')
      .add('bubble10', 'images/bubble/bubble-10.png')
      .add('bubble11', 'images/bubble/bubble-11.png')
      .add('bubble12', 'images/bubble/bubble-12.png')
      .add('bubble13', 'images/bubble/bubble-13.png')
      .add('bubble14', 'images/bubble/bubble-14.png')
      .add('bubble15', 'images/bubble/bubble-15.png')

      // Intro
      .add('info', 'images/intro/info.png')
      .add('introText', 'images/intro/text.png')

      // Buttons
      .add('btnGoToSleep', 'images/buttons/go-to-sleep.png')
      .add('btnGoToLanding', 'images/buttons/go-to-landing.png')
      .add('btnShare', 'images/buttons/share.png')
      .add('btnSharePlayAgain', 'images/buttons/share-play-again-new.png')
      .add('btnSecret', 'images/buttons/secret.png')
      .add('btnIKnow', 'images/buttons/i-know.png')
      .add('btnRule', 'images/buttons/rule.png')
      .add('btnHowToPlay', 'images/buttons/how-to-play.png')

      // Text
      .add('scene1Text', 'images/text/scene1-1-text-new3.png')
      .add('scene2Title', 'images/text/scene2-1-text.png')

      // Numbers
      .add('day', 'images/numbers/day.png')
      .add('clock', 'images/numbers/clock.png')
      .add('colon', 'images/numbers/colon.png')
      .add('big_num_0', 'images/numbers/big_num_0.png')
      .add('big_num_1', 'images/numbers/big_num_1.png')
      .add('big_num_2', 'images/numbers/big_num_2.png')
      .add('num_0', 'images/numbers/num_0.png')
      .add('num_1', 'images/numbers/num_1.png')
      .add('num_2', 'images/numbers/num_2.png')
      .add('num_3', 'images/numbers/num_3.png')
      .add('num_4', 'images/numbers/num_4.png')
      .add('num_5', 'images/numbers/num_5.png')
      .add('num_6', 'images/numbers/num_6.png')
      .add('num_7', 'images/numbers/num_7.png')
      .add('num_8', 'images/numbers/num_8.png')
      .add('num_9', 'images/numbers/num_9.png')

      // Game
      .add('gameOver', 'images/game/game_over.png')
      .add('pause', 'images/game/pause.png')
      .add('play', 'images/game/play.png')
      .add('scoreBoard', 'images/game/score-board-new.png')
      .add('scoreBoardPlayAgain', 'images/game/play-again.png')
      .add('sheep1', 'images/game/sheep-1.png')
      .add('sheep2', 'images/game/sheep-2.png')
      .add('sheep3', 'images/game/sheep-3.png')
      .add('rainbowSheep1', 'images/game/rainbow-sheep-1.png')
      .add('rainbowSheep2', 'images/game/rainbow-sheep-2.png')
      .add('rainbowSheep3', 'images/game/rainbow-sheep-3.png')
      .add('sheepBubble', 'images/game/bubble.png')
      .add('tutorialKey1', 'images/game/key-1.png')
      .add('tutorialKey2', 'images/game/key-2.png')
      .add('tutorialPhone1', 'images/game/phone-1.png')
      .add('tutorialPhone2', 'images/game/phone-2.png')
      .add('tutorialPhone3', 'images/game/phone-3.png')
      .add('ruleHint', 'images/game/rule-hint.png')
      .add('inputDone', 'images/game/input-done.png')
      .add('input', 'images/game/input.png')
      .add('credit', 'images/game/credit-new.png')

      // Mattress
      .add('cool1', 'images/mattress/cool-1.png')
      .add('cool2', 'images/mattress/cool-2.png')
      .add('foam1', 'images/mattress/foam-1.png')
      .add('foam2', 'images/mattress/foam-2.png')
      .add('spring1', 'images/mattress/spring-1.png')
      .add('spring2', 'images/mattress/spring-2.png')
      .add('spring3', 'images/mattress/spring-3.png')

      // Scores
      .add('score-1-1', 'images/scores/score-1-1.png')
      .add('score-1-2', 'images/scores/score-1-2.png')
      .add('score-1-3', 'images/scores/score-1-3.png')
      .add('score-7-1', 'images/scores/score-7-1.png')
      .add('score-7-2', 'images/scores/score-7-2.png')
      .add('score-7-3', 'images/scores/score-7-3.png')
      .add('score-8-1', 'images/scores/score-8-1.png')
      .add('score-8-2', 'images/scores/score-8-2.png')
      .add('score-8-3', 'images/scores/score-8-3.png')
      .add('jumper1', 'images/scores/jumper-1.png')
      .add('jumper2', 'images/scores/jumper-2.png')
      .add('jumper3', 'images/scores/jumper-3.png')
      .add('jumper4', 'images/scores/jumper-4.png')
      .add('jumper5', 'images/scores/jumper-5.png')
      .add('jumper6', 'images/scores/jumper-6.png')
      .add('jumper7', 'images/scores/jumper-7.png')

      .on('progress', this.onLoading.bind(this))
      .load(this.onComplete.bind(this))
  }

  onLoading (loader) {
    this.objects.counter.text = `${Math.floor(loader.progress)}%`
    this.objects.man.alpha = 1 - (loader.progress / 100)
    this.manBlurFilter.blur = (loader.progress / 100) * 2
    this.objects.manInSleep.alpha = loader.progress / 100
  }

  onComplete (loader, resources) {
    this.objects.counter.text = '100%'

    const timer = setTimeout(() => {
      this.game.app.stage.removeChild(
        this.objects.title,
        this.objects.man,
        this.objects.manInSleep,
        this.objects.counter
      )

      this.objects.title.destroy()
      this.objects.man.destroy()
      this.objects.manInSleep.destroy()
      this.objects.counter.destroy()

      this.objects = null
      this.manBlurFilter = null

      this.onLoaded(this.game)

      clearTimeout(timer)
    }, 900)
  }
}

export default Progress
